import React from 'react';
import DiIconSpinner from "../icons/di-icon-spinner";

export default function Loader(props) {
    return React.createElement(
        'div',
        { style: {
                display: props.menuHeight && !props.engineReady || props.loadingModel ? 'flex' : 'none',
                height: props.menuHeight + 'px',
                overflow: 'hidden',
                backgroundColor: '#ea7c19'
            },
            className: 'engineNotReady abste' },
        React.createElement('img', { style: { height: props.menuHeight + 'px' },
            src: props.loaderImage }),
        React.createElement(DiIconSpinner, { className: 'spinner' })
    );
}